import React, { PureComponent } from 'react'
import styles from './styles'

import Survey from 'app/Components/Survey'
import { ThankYou } from 'app/Components/Survey/Panel'

export default class ThankYouPage extends PureComponent {
  render() {
    return (
      <div className={styles.wrapper}>
        <ThankYou>
          <p> Thank you for reaching out, we apperciate your time. </p>
        </ThankYou>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./form/thank-you/index.js
 **/